export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال رمز التوثيق عبر الرسائل القصيرة إلى ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تعذر إرسال الرسالة. يرجى التحقق من دخولك."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم إرسال رمز المصادقة عبر الرسائل القصيرة. يمكن استخدامه مرة واحدة فقط وضمن فترة زمنية محدودة لتسجيل الدخول."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة عبر الرسائل القصيرة"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل مرة أخرى"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل وتأكد من استلام رمز المصادقة."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثوان"])}
        }
      },
      "ar-DZ": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال رمز التوثيق عبر الرسائل القصيرة إلى ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              
            }
          }
        },
        "SMSOTPForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل مرة أخرى"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل وتأكد من استلام رمز المصادقة."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثوان"])}
        }
      },
      "ar-EG": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال رمز التوثيق عبر الرسائل القصيرة إلى ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تعذر إرسال الرسالة. يرجى التحقق من دخولك."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم إرسال رمز المصادقة عبر الرسائل القصيرة. يمكن استخدامه مرة واحدة فقط وضمن فترة زمنية محدودة لتسجيل الدخول."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة عبر الرسائل القصيرة"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل مرة أخرى"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل وتأكد من استلام رمز المصادقة."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثوان"])}
        }
      },
      "ar-LB": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال رمز التوثيق عبر الرسائل القصيرة إلى ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              
            }
          }
        },
        "SMSOTPForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل مرة أخرى"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل وتأكد من استلام رمز المصادقة."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثواني"])}
        }
      },
      "ar-MA": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال رمز التوثيق عبر الرسائل القصيرة إلى ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              
            }
          }
        },
        "SMSOTPForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل مرة أخرى"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل وتأكد من استلام رمز المصادقة."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ادخل رمز التأكيد"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثوان"])}
        }
      },
      "ar-SA": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال رمز التوثيق عبر الرسائل القصيرة إلى ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تعذر إرسال الرسالة. يرجى التحقق من دخولك."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم إرسال رمز المصادقة عبر الرسائل القصيرة. يمكن استخدامه مرة واحدة فقط وضمن فترة زمنية محدودة لتسجيل الدخول."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة عبر الرسائل القصيرة"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أعد الإرسال"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل وتأكد من استلام رمز المصادقة."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثوان"])}
        }
      },
      "ar-SY": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال رمز التوثيق عبر الرسائل القصيرة إلى ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              
            }
          }
        },
        "SMSOTPForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل مرة أخرى"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل وتأكد من استلام رمز المصادقة."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثوان"])}
        }
      },
      "ar-TN": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال رمز التوثيق عبر الرسائل القصيرة إلى ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              
            }
          }
        },
        "SMSOTPForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل مرة أخرى"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل وتأكد من استلام رمز المصادقة."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثواني"])}
        }
      },
      "bg-BG": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Кодът за удостоверяване беше изпратен чрез СМС до ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Съобщението не можа да бъде изпратено. Моля, проверете вашето въвеждане."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кодът за удостоверяване беше изпратен чрез SMS. Може да се използва само веднъж и в рамките на ограничено време за влизане."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код за удостоверяване чрез SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изпрати отново"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Въведете и потвърдете получения код за удостоверяване."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Потвърждение"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Въведете код за удостоверяване"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Преизпрати след ", _interpolate(_named("secondsPlaceholder")), " секунди"])}
        }
      },
      "bs-BA": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentifikacijski kod je poslan putem SMS-a na ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poruka se nije mogla poslati. Molimo provjerite svoj unos."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod za autentifikaciju je poslan putem SMS-a. Može se koristiti samo jednom iu ograničenom vremenu za prijavu."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijski kod putem SMS-a"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pošalji ponovo"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unesite i potvrdite primljeni kod za autentifikaciju."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdite"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unesite kod za autentifikaciju"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ponovno pošalji za ", _interpolate(_named("secondsPlaceholder")), " sekundi"])}
        }
      },
      "cs-CZ": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ověřovací kód byl odeslán pomocí SMS na ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zprávu se nepodařilo odeslat. Zkontrolujte prosím svůj údaj."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřovací kód byl zaslán prostřednictvím SMS. Lze jej použít pouze jednou a po omezenou dobu pro přihlášení."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřovací kód prostřednictvím SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poslat znovu"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadejte a potvrďte přijatý ověřovací kód."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdit"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadejte ověřovací kód"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Znovu odeslat za ", _interpolate(_named("secondsPlaceholder")), " sekundy"])}
        }
      },
      "da-DK": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Godkendelseskoden blev sendt via SMS til ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Meddelelsen kunne ikke sendes. Tjek venligst din post."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskoden blev sendt via SMS. Det kan kun bruges én gang og inden for en begrænset tid til at logge ind."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskode via SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send igen"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indtast og bekræft den modtagne godkendelseskode."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekræft"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indtast godkendelseskode"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Gensend om ", _interpolate(_named("secondsPlaceholder")), " sekunder"])}
        }
      },
      "de-DE": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Der Authentifizierungscode wurde per SMS an ", _interpolate(_named("mobileNumberPlaceholder")), " gesendet."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Die Nachricht konnte nicht gesendet werden. Bitte prüfe deine Eingabe."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde per SMS gesendet. Er kann nur einmalig und innerhalb einer begrenzten Zeit für die Anmeldung verwendet werden."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode per SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erneut senden"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfangenen Authentifizierungscode eingeben und bestätigen."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode eingeben"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("secondsPlaceholder")), " Sekunden"])}
        }
      },
      "de-AT": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Der Authentifizierungscode wurde per SMS an ", _interpolate(_named("mobileNumberPlaceholder")), " gesendet."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Die Nachricht konnte nicht gesendet werden. Bitte prüfe deine Eingabe."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde per SMS gesendet. Er kann nur einmalig und innerhalb einer begrenzten Zeit für die Anmeldung verwendet werden."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode per SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erneut senden"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfangenen Authentifizierungscode eingeben und bestätigen."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode eingeben"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("secondsPlaceholder")), " Sekunden"])}
        }
      },
      "de-CH": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Der Authentifizierungscode wurde per SMS an ", _interpolate(_named("mobileNumberPlaceholder")), " gesendet."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Die Nachricht konnte nicht gesendet werden. Bitte prüfe deine Eingabe."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde per SMS gesendet. Er kann nur einmalig und innerhalb einer begrenzten Zeit für die Anmeldung verwendet werden."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode per SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erneut senden"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfangenen Authentifizierungscode eingeben und bestätigen."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode eingeben"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("secondsPlaceholder")), " Sekunden"])}
        }
      },
      "de-LU": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde per SMS an mobileNumberPlaceholder gesendet."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              
            }
          }
        },
        "SMSOTPForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erneut senden"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfangenen Authentifizierungscode eingeben und bestätigen."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode eingeben"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("secondsPlaceholder")), " Sekunden"])}
        }
      },
      "el-GR": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ο κωδικός επιβεβαίωσης στάλθηκε μέσω SMS στον ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν ήταν δυνατή η αποστολή του μηνύματος. Ελέγξτε την καταχώρισή σας."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός ελέγχου ταυτότητας στάλθηκε μέσω SMS. Μπορεί να χρησιμοποιηθεί μόνο μία φορά και εντός περιορισμένου χρόνου για τη σύνδεση."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός ελέγχου ταυτότητας μέσω SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Στείλε ξανά"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εισαγάγετε και επιβεβαιώστε τον κωδικό ελέγχου ταυτότητας που λάβατε."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαίωση"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εισάγετε τον κωδικό επαλήθευσης"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Επανάληψη αποστολής σε ", _interpolate(_named("secondsPlaceholder")), " δευτερόλεπτα"])}
        }
      },
      "el-CY": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ο κωδικός επιβεβαίωσης στάλθηκε μέσω SMS στον ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν ήταν δυνατή η αποστολή του μηνύματος. Ελέγξτε την καταχώρισή σας."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός ελέγχου ταυτότητας στάλθηκε μέσω SMS. Μπορεί να χρησιμοποιηθεί μόνο μία φορά και εντός περιορισμένου χρόνου για τη σύνδεση."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός ελέγχου ταυτότητας μέσω SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Στείλε ξανά"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εισαγάγετε και επιβεβαιώστε τον κωδικό ελέγχου ταυτότητας που λάβατε."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαίωση"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εισάγετε τον κωδικό επαλήθευσης"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Επανάληψη αποστολής σε ", _interpolate(_named("secondsPlaceholder")), " δευτερόλεπτα"])}
        }
      },
      "en-GB": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["The authentication code was sent via SMS to ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful Action"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The message could not be sent. Please check your entry."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code was sent via SMS. It can only be used once and within a limited time for logging in.."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication code by SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resend"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter and confirm the authentication code received."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter authentication code"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Resend in ", _interpolate(_named("secondsPlaceholder")), " Seconds"])}
        }
      },
      "en-IE": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["The authentication code was sent via SMS to ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful Action"])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              
            }
          }
        },
        "SMSOTPForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resend"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter and confirm the authentication code received."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter authentication code"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Resend in ", _interpolate(_named("secondsPlaceholder")), " Seconds"])}
        }
      },
      "en-US": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["The authentication code was sent via SMS to ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful Action"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The message could not be sent. Please check your entry."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code was sent via SMS. It can only be used once and within a limited time for logging in.."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication code by SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resend"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter and confirm the authentication code received."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter authentication code"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Resend in ", _interpolate(_named("secondsPlaceholder")), " Seconds"])}
        }
      },
      "es-ES": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["El código de autenticación se envió por SMS a ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El mensaje no se pudo enviar. Por favor revise su entrada."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El código de autenticación se envió por SMS. Solo se puede usar una vez y dentro de un tiempo limitado para iniciar sesión."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticación por SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar de nuevo"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Introduzca y confirme el código de autenticación recibido."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingrese el código de autenticación"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Volver a enviar en ", _interpolate(_named("secondsPlaceholder")), " segundos"])}
        }
      },
      "et-EE": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentimiskood saadeti SMS-i teel ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sõnumit ei õnnestunud saata. Palun kontrollige oma sisestust."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskood saadeti SMS-iga. Seda saab kasutada ainult üks kord ja piiratud aja jooksul sisselogimiseks."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskood SMS-i teel"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saada uuesti"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sisestage ja kinnitage saadud autentimiskood."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kinnita"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sisestage autentimiskood"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Saada uuesti ", _interpolate(_named("secondsPlaceholder")), " sekundi pärast"])}
        }
      },
      "fi-FI": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Vahvistuskoodi lähetettiin tekstiviestillä osoitteeseen ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viestiä ei voitu lähettää. Tarkista syöttösi."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodi lähetettiin tekstiviestillä. Sitä voidaan käyttää vain kerran ja rajoitetun ajan sisällä kirjautumiseen."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodi tekstiviestillä"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lähetä uudestaan"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Syötä ja vahvista vastaanotettu todennuskoodi."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vahvista"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kirjoita tunnistekoodi"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Lähetä uudelleen ", _interpolate(_named("secondsPlaceholder")), " sekunnin kuluttua"])}
        }
      },
      "fr-BE": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Le code d'authentification a été envoyé par SMS à ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le message n'a pas pu être envoyé. Veuillez vérifier votre saisie."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification a été envoyé par SMS. Il ne peut être utilisé qu'une seule fois et dans un délai limité pour se connecter."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification par SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renvoyer"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez et confirmez le code d'authentification reçu."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez le code d'authentification"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("secondsPlaceholder")), " secondes"])}
        }
      },
      "fr-CH": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Le code d'authentification a été envoyé par SMS à ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              
            }
          }
        },
        "SMSOTPForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renvoyer"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez et confirmez le code d'authentification reçu."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saisir le code d'authentification"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("secondsPlaceholder")), " secondes"])}
        }
      },
      "fr-FR": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Le code d'authentification a été envoyé par SMS à ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le message n'a pas pu être envoyé. Veuillez vérifier votre saisie."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification a été envoyé par SMS. Il ne peut être utilisé qu'une seule fois et dans un délai limité pour se connecter."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification par SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer à nouveau"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez et confirmez le code d'authentification reçu."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saisir le code d'authentification"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("secondsPlaceholder")), " secondes"])}
        }
      },
      "fr-LU": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Le code d'authentification a été envoyé par SMS à ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le message n'a pas pu être envoyé. Veuillez vérifier votre saisie."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification a été envoyé par SMS. Il ne peut être utilisé qu'une seule fois et dans un délai limité pour se connecter."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification par SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renvoyer"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez et confirmez le code d'authentification reçu."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saisir le code d'authentification"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("secondsPlaceholder")), " secondes"])}
        }
      },
      "ga-IE": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Seoladh cód deimhnithe via SMS go ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ní fhéadfaí an teachtaireacht a sheoladh. Seiceáil d’iontráil le do thoil."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seoladh an cód fíordheimhnithe trí SMS. Ní féidir é a úsáid ach uair amháin agus laistigh de thréimhse teoranta chun logáil isteach."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cód fíordheimhnithe trí SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seol arís"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuir isteach agus deimhnigh an cód fíordheimhnithe a fuarthas."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deimhnigh"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuir isteach cód fíordheimhnithe"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Athseoladh i ", _interpolate(_named("secondsPlaceholder")), " soicind"])}
        }
      },
      "he-IL": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["קוד האימות נשלח באמצעות הודעת טקסט אל ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לא ניתן היה לשלוח את ההודעה. אנא בדוק את הערך שלך."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד האימות נשלח באמצעות SMS. ניתן להשתמש בו רק פעם אחת ובתוך זמן מוגבל לכניסה."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד אימות באמצעות SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שלח שוב"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הזן ואשר את קוד האימות שהתקבל."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְאַשֵׁר"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הזן קוד אימות"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["שלח מחדש בעוד ", _interpolate(_named("secondsPlaceholder")), " שניות"])}
        }
      },
      "hi-IN": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["प्रमाणीकरण कोड को ", _interpolate(_named("mobileNumberPlaceholder")), " को एसएमएस के माध्यम से भेजा गया था।"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सफल कार्रवाई"])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["त्रुटि"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              
            }
          }
        },
        "SMSOTPForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["फिर से भेजें"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्राप्त प्रमाणीकरण कोड दर्ज करें और पुष्टि करें।"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पुष्टि करें"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रमाणीकरण कोड दर्ज करें"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("secondsPlaceholder")), " सेकंड में पुन: भेजें"])}
        }
      },
      "hr-HR": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentifikacijski kod je poslan putem SMS-a na ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poruka se nije mogla poslati. Molimo provjerite svoj unos."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod za autentifikaciju poslan je putem SMS-a. Može se koristiti samo jednom i unutar ograničenog vremena za prijavu."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijski kod putem SMS-a"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pošalji opet"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unesite i potvrdite primljeni autentifikacijski kod."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrda"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unesite autentifikacijski kod"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ponovno pošalji za ", _interpolate(_named("secondsPlaceholder")), " sekundi"])}
        }
      },
      "hu-HU": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Az hitelesítő kód SMS-ben lett elküldve a ", _interpolate(_named("mobileNumberPlaceholder")), " számra."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Az üzenetet nem sikerült elküldeni. Kérjük, ellenőrizze a bejegyzést."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A hitelesítési kódot SMS-ben küldték el. Csak egyszer és korlátozott ideig használható a bejelentkezéshez."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hitelesítési kód SMS-ben"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Küldd újra"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Írja be és erősítse meg a kapott hitelesítési kódot."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Megerősít"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adja meg az hitelesítő kódot"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Újraküldés ", _interpolate(_named("secondsPlaceholder")), " másodperc múlva"])}
        }
      },
      "it-CH": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Il codice di autenticazione è stato inviato tramite SMS a ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione di successo"])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              
            }
          }
        },
        "SMSOTPForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invia di nuovo"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserisci e conferma il codice di autenticazione ricevuto."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confermare"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserire il codice di autenticazione"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Invia di nuovo fra ", _interpolate(_named("secondsPlaceholder")), " secondi"])}
        }
      },
      "it-IT": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Il codice di autenticazione è stato inviato tramite SMS a ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impossibile inviare il messaggio. Si prega di controllare la tua voce."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il codice di autenticazione è stato inviato tramite SMS. Può essere utilizzato solo una volta ed entro un tempo limitato per l'accesso."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codice di autenticazione via SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invia di nuovo"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserisci e conferma il codice di autenticazione ricevuto."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conferma"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserire il codice di autenticazione"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Invia di nuovo fra ", _interpolate(_named("secondsPlaceholder")), " secondi"])}
        }
      },
      "ja-JP": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["認証コードは、SMSで", _interpolate(_named("mobileNumberPlaceholder")), "に送信されました。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["メッセージを送信できませんでした。 入力内容をご確認ください。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードは SMS 経由で送信されました。 ログイン時に1回限り、限られた時間内でのみ使用できます。"])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS経由の認証コード"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["もう一度送信"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["受信した認証コードを入力して確認します。"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確認"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードを入力してください"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("secondsPlaceholder")), " 秒後に再送信"])}
        }
      },
      "ko-KR": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["인증 코드가 ", _interpolate(_named("mobileNumberPlaceholder")), "에게 SMS로 전송되었습니다."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["성공적인 액션"])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["오류"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              
            }
          }
        },
        "SMSOTPForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["다시 보내기"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["받은 인증 코드를 입력하고 확인하십시오."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["확인"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["인증 코드를 입력하세요"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("secondsPlaceholder")), "초 후에 재전송"])}
        }
      },
      "lt-LT": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentifikavimo kodas buvo išsiųstas SMS žinute į ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nepavyko išsiųsti pranešimo. Patikrinkite savo įrašą."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo kodas buvo išsiųstas SMS žinute. Jį galima naudoti tik vieną kartą ir per ribotą prisijungimo laiką."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo kodas SMS žinute"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Siųsti dar kartą"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įveskite ir patvirtinkite gautą autentifikavimo kodą."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Patvirtinti"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įveskite autentifikacijos kodą"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Persiųsti po ", _interpolate(_named("secondsPlaceholder")), " sekundžių"])}
        }
      },
      "lv-LV": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentifikācijas kods tika nosūtīts caur SMS uz ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ziņojumu nevarēja nosūtīt. Lūdzu, pārbaudiet savu ierakstu."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods tika nosūtīts ar SMS. To var izmantot tikai vienu reizi un ierobežotā laikā, lai pieteiktos."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods, izmantojot īsziņu"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sūtīt vēlreiz"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ievadiet un apstipriniet saņemto autentifikācijas kodu."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apstiprināt"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ievadiet autentifikācijas kodu"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Atkārtoti nosūtīt pēc ", _interpolate(_named("secondsPlaceholder")), " sekundēm"])}
        }
      },
      "mt-MT": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Il-kodiċi ta' awtentikazzjoni ġie mibgħut permezz ta' SMS lil ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-messaġġ ma setax jintbagħat. Jekk jogħġbok iċċekkja d-dħul tiegħek."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-kodiċi ta' awtentikazzjoni intbagħat permezz ta' SMS. Jista 'jintuża darba biss u fi żmien limitat għall-illoggjar."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kodiċi ta 'awtentikazzjoni permezz ta' SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ibgħat mill-ġdid"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Daħħal u kkonferma l-kodiċi ta 'awtentikazzjoni riċevut."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkonferma"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Idħol il-kodiċi ta' awtentikazzjoni"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ibgħat mill-ġdid fi ", _interpolate(_named("secondsPlaceholder")), " sekondi"])}
        }
      },
      "nb-NO": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentiseringskoden ble sendt via SMS til ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Feil"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              
            }
          }
        },
        "SMSOTPForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send igjen"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skriv inn og bekreft autentiseringskoden du mottok."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekrefte"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skriv inn godkjenningskode"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Send på nytt om ", _interpolate(_named("secondsPlaceholder")), " sekunder"])}
        }
      },
      "nl-BE": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["De authenticatiecode werd via SMS naar ", _interpolate(_named("mobileNumberPlaceholder")), " gestuurd."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              
            }
          }
        },
        "SMSOTPForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opnieuw verzenden"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voer de ontvangen authenticatiecode in en bevestig deze."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bevestigen"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voer de authenticatiecode in"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Opnieuw verzenden over ", _interpolate(_named("secondsPlaceholder")), " seconden"])}
        }
      },
      "nl-NL": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["De authenticatiecode werd via SMS naar ", _interpolate(_named("mobileNumberPlaceholder")), " gestuurd."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Het bericht kon niet worden verzonden. Controleer uw invoer."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De authenticatiecode is per sms verzonden. Het kan slechts één keer en binnen een beperkte tijd worden gebruikt om in te loggen."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatiecode via sms"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opnieuw verzenden"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voer de ontvangen authenticatiecode in en bevestig deze."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bevestigen"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voer de authenticatiecode in"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Opnieuw verzenden over ", _interpolate(_named("secondsPlaceholder")), " seconden"])}
        }
      },
      "pl-PL": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kod autoryzacyjny został wysłany za pośrednictwem SMS na ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie udało się wysłać wiadomości. Sprawdź swój wpis."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniający został wysłany SMS-em. Można go użyć tylko raz iw ograniczonym czasie do zalogowania."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniający przez SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wyślij ponownie"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wprowadź i potwierdź otrzymany kod uwierzytelniający."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potwierdź"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wprowadź kod uwierzytelniania"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Wyślij ponownie za ", _interpolate(_named("secondsPlaceholder")), " sekund"])}
        }
      },
      "pt-PT": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["O código de autenticação foi enviado por SMS para ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A mensagem não pôde ser enviada. Por favor, verifique sua entrada."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O código de autenticação foi enviado via SMS. Ele só pode ser usado uma vez e dentro de um tempo limitado para fazer login."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticação via SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envie novamente"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Digite e confirme o código de autenticação recebido."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Insira o código de autenticação"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Reenviar em ", _interpolate(_named("secondsPlaceholder")), " segundos"])}
        }
      },
      "ro-RO": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Codul de autentificare a fost trimis prin SMS la ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mesajul nu a putut fi trimis. Vă rugăm să verificați intrarea."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare a fost trimis prin SMS. Poate fi folosit o singură dată și într-un timp limitat pentru autentificare."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cod de autentificare prin SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trimite din nou"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Introduceți și confirmați codul de autentificare primit."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmare"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Introduceți codul de autentificare"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Retrimite în ", _interpolate(_named("secondsPlaceholder")), " secunde"])}
        }
      },
      "ru-RU": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Код аутентификации был отправлен по SMS на ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сообщение не может быть отправлено. Пожалуйста, проверьте вашу запись."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации был отправлен в SMS. Его можно использовать только один раз и в течение ограниченного времени для входа в систему."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации по SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отправь еще раз"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введите и подтвердите полученный код аутентификации."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Подтвердить"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введите код аутентификации"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Отправить снова через ", _interpolate(_named("secondsPlaceholder")), " секунд"])}
        }
      },
      "sk-SK": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentifikačný kód bol odoslaný pomocou SMS na ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Správu sa nepodarilo odoslať. Skontrolujte svoje zadanie."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Overovací kód bol odoslaný prostredníctvom SMS. Dá sa použiť len raz a v obmedzenom čase na prihlásenie."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikačný kód prostredníctvom SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poslať znova"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadajte a potvrďte prijatý overovací kód."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdiť"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadajte overovací kód"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Znovu poslať o ", _interpolate(_named("secondsPlaceholder")), " sekundy"])}
        }
      },
      "sl-SI": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Avtentikacijska koda je bila poslana preko SMS na ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sporočila ni bilo mogoče poslati. Prosimo, preverite svoj vnos."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koda za preverjanje pristnosti je bila poslana prek SMS-a. Uporabite ga lahko samo enkrat in v omejenem času za prijavo."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koda za preverjanje pristnosti prek SMS-a"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pošlji ponovno"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vnesite in potrdite prejeto kodo za preverjanje pristnosti."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potrdi"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vnesite kodo za preverjanje pristnosti"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ponovno pošlji čez ", _interpolate(_named("secondsPlaceholder")), " sekund"])}
        }
      },
      "sv-SE": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentiseringskoden skickades via SMS till ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Meddelandet kunde inte skickas. Kontrollera ditt bidrag."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden skickades via SMS. Den kan endast användas en gång och inom en begränsad tid för inloggning."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskod via SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skicka igen"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ange och bekräfta den mottagna autentiseringskoden."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekräfta"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ange autentiseringskod"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Skicka igen om ", _interpolate(_named("secondsPlaceholder")), " sekunder"])}
        }
      },
      "th-TH": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["รหัสการตรวจสอบถูกส่งผ่าน SMS ไปยัง ", _interpolate(_named("mobileNumberPlaceholder"))])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["การดำเนินการที่ประสบความสำเร็จ"])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ความผิดพลาด"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              
            }
          }
        },
        "SMSOTPForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ส่งอีกครั้ง"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ป้อนและยืนยันรหัสการรับรองที่ได้รับ"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ยืนยัน"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ป้อนรหัสยืนยัน"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["ส่งใหม่ใน ", _interpolate(_named("secondsPlaceholder")), " วินาที"])}
        }
      },
      "tr-CY": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kimlik doğrulama kodu, SMS ile ", _interpolate(_named("mobileNumberPlaceholder")), "'a gönderildi."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mesaj gönderilemedi. Lütfen girişinizi kontrol edin."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu SMS ile gönderildi. Giriş yapmak için yalnızca bir kez ve sınırlı bir süre içinde kullanılabilir."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS ile doğrulama kodu"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tekrar gönderin"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alınan doğrulama kodunu girin ve onaylayın."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onayla"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama kodunu girin"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("secondsPlaceholder")), " saniye sonra yeniden gönder"])}
        }
      },
      "tr-TR": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kimlik doğrulama kodu, SMS ile ", _interpolate(_named("mobileNumberPlaceholder")), "'a gönderildi."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mesaj gönderilemedi. Lütfen girişinizi kontrol edin."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu SMS ile gönderildi. Giriş yapmak için yalnızca bir kez ve sınırlı bir süre içinde kullanılabilir."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS ile doğrulama kodu"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tekrar gönderin"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alınan doğrulama kodunu girin ve onaylayın."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onayla"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama kodunu girin"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("secondsPlaceholder")), " saniye sonra yeniden gönder"])}
        }
      },
      "uk-UA": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Код автентифікації був відправлений через SMS на ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успішна дія"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Die Nachricht konnte nicht gesendet werden. Bitte prüfe deine Eingabe."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Помилка"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успішна акція"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код автентифікації надіслано через SMS. Його можна використовувати лише один раз і протягом обмеженого часу для входу."])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код автентифікації через SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Надіслати знову"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введіть і підтвердьте отриманий код автентифікації."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Підтвердити"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введіть код автентифікації"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Надіслати знову за ", _interpolate(_named("secondsPlaceholder")), " секунд"])}
        }
      },
      "vi-VN": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Mã xác thực đã được gửi qua SMS đến ", _interpolate(_named("mobileNumberPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hành động thành công"])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lỗi"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              
            }
          }
        },
        "SMSOTPForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gửi lại"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nhập và xác nhận mã xác thực đã nhận."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Xác nhận"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nhập mã xác thực"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Gửi lại sau ", _interpolate(_named("secondsPlaceholder")), " giây"])}
        }
      },
      "zh-CN": {
        "notification": {
          "sendSMS": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["身份验证代码已通过短信发送至", _interpolate(_named("mobileNumberPlaceholder")), "。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["无法发送消息。 请检查您的输入。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
            }
          }
        },
        "smsSent": {
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["验证码是通过短信发送的。 仅限登录一次，限时使用。"])}
            }
          }
        },
        "SMSOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通过短信验证码"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重新发送"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入并确认收到的验证码。"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认"])}
        },
        "SMSOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请输入认证码"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("secondsPlaceholder")), " 秒后重新发送"])}
        }
      }
    }
  })
}
